import { render, staticRenderFns } from "./jgevaluationList.vue?vue&type=template&id=b260946e&scoped=true"
import script from "./jgevaluationList.vue?vue&type=script&lang=js"
export * from "./jgevaluationList.vue?vue&type=script&lang=js"
import style0 from "./jgevaluationList.vue?vue&type=style&index=0&id=b260946e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b260946e",
  null
  
)

export default component.exports